import { useContext, useEffect, useState } from 'react';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import SecondaryButton from "../../ui/SecondaryButton";
import TextBox from '../../ui/TextBox';
import IfmsDate from '../../ui/Date';
import Float from '../../ui/Float';
import { InvoiceListItem } from '../../fms.data/models/InvoiceListItem';
import { Edi310Header, EdiSharedInfo } from '../../fms.core/Edi310Header';
import { ApiResult } from '../../framework.core/data/ApiResult';
import ApplicationContext from '../../ApplicationContext';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import numeral from 'numeral';
import moment from 'moment';
import { appendLine } from '../../util';
import constants from '../../constants';

interface Edi310StorageKeys {
  modelStorage: string,
};

interface Edi310Params {
  selectedElement: InvoiceListItem,
  onPopupClose?: () => void,
};

interface Edi310LoadedParams {
  edi310: Edi310Header,
  setEdi310: (x: Partial<Edi310Header>) => void,
  selectedElement: InvoiceListItem,
  onPopupClose?: () => void,
  clickEDI: () => void,
  run: boolean
};

function getStorageKeys(): Edi310StorageKeys {
  return { modelStorage: 'common-edi-310' }
}

function Edi310Impl(params: Edi310Params) {
  const { modelStorage } = getStorageKeys();
  const { selectedElement } = params;
  const [edi310, setEdi310, removeFromStorage] = useTypedFastStorage<Edi310Header>(modelStorage, null);

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [run, setRun] = useState(false);
  const appContext = useContext(ApplicationContext);

  useEffect(() => {
    initialize();
    return () => removeFromStorage()
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function loadExisting(): Promise<any> {
    const apiResult: ApiResult<Edi310Header> = await appContext.api.getEDI310(selectedElement.id);
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return;
    }
    return apiResult.result;
  }

  async function initialize() {
    const data = await loadExisting();

    if (data) {
      setEdi310({ ...data });
    }
  }

  if (edi310 === null) {
    return null;
  }

  async function clickEDI() {
    setRun(true);
    if (edi310?.ftpID === '' && edi310.ftpPassword === '' && edi310.ftpOutFolder === '' && edi310.ftpScac === '') {
      await showGlobalOkDialog(<p>EDI Gateway is not setting.</p>);
      return;
    }

    var errMsg = await faCheckData();

    if (errMsg !== '') {
      await showGlobalOkDialog(<p>Please check following information. (Specify the missing entries.)<br />
        {errMsg}
      </p>);
      return;
    }

    var invoHdIds = edi310?.lines[0].invoiceId.toString();
    var receiverId = '';
    var receiverIdq = '';
    var senderId = '';
    var senderIdq = '';

    if (edi310 && edi310.receiverID !== '' && edi310.receiverID.indexOf(':') >= 0) {
      receiverId = edi310.receiverID.substring(4);
      receiverIdq = edi310.receiverID.substring(0, 2);
    }
    else {
      receiverId = edi310?.receiverID ?? '';
      receiverIdq = 'ZZ';
    }

    if (edi310 && edi310?.senderID !== '' && edi310?.senderID.indexOf(':') >= 0) {
      senderId = edi310.senderID.substring(4);
      senderIdq = edi310.senderID.substring(0, 2);
    }
    else {
      senderId = edi310?.senderID ?? '';
      senderIdq = 'ZZ';
    }

    const ediInfo = new EdiSharedInfo({
      receiverID: receiverId,
      receiverIdQualifier: receiverIdq,
      senderID: senderId,
      senderIdQualifier: senderIdq,
      fileName: `EDI${moment().format('yyyyMMdd')}${numeral(edi310?.ediSeqNo).format('D8')}.TXT`
    });

    const apiResult = await appContext.api.make310(ediInfo, selectedElement.jobType,
      invoHdIds, 'c:\\temp', edi310?.ftpScac, edi310?.ediSeqNo);
    //const apiResult = await appContext.api.make310(jobtype:selectedElement.jobType, invoHdIds : invoHdIds,tempDir : '',ediInfo : ediInfo,ftpScac: edi310?.ftpScac, ediSeqNo : edi310?.ediSeqNo);
    if (apiResult && apiResult.success) {
      await showGlobalOkDialog(<p>Success !!!</p>);
      setRun(false);
      return;
    }
    else {
      var msg = apiResult?.result?.length !== 0 ? apiResult.result : 'Failed !!!';
      setRun(false);
      await showGlobalOkDialog(<p>{msg}</p>);
    }
  }

  async function faCheckData() {
    let errMsg = '';

    if (edi310?.receiverID === '')
      errMsg = '* You must input Receiver';
    if (edi310?.senderID === '')
      errMsg = appendLine(errMsg, '* You must input Sender');
    return errMsg;
  }

  return (
    <Edi310InitializedImpl
      edi310={edi310}
      setEdi310={setEdi310}
      selectedElement={selectedElement}
      clickEDI={clickEDI}
      onPopupClose={params.onPopupClose}
      run={run}
    />
  );
}

function Edi310InitializedImpl({
  edi310,
  setEdi310,
  selectedElement,
  onPopupClose,
  clickEDI,
  run
}: Edi310LoadedParams) {


  return (
    <div className='report-popup'>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '320px' }}>
          <InlineInputControlRow label="Invoice To" mode="smaller-2x">
            <TextBox value={edi310.billToName} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Invoice Date" mode="smaller-2x">
            <div style={{ display: 'flex' }}>
              <div style={{ width: '80px' }}>
                <IfmsDate value={edi310.lines[0].invoiceDate} disabled />
              </div>

              <div style={{ width: '40px', textAlign: 'center' }}>
                ~
              </div>

              <div style={{ width: '80px' }}>
                <IfmsDate value={edi310.lines[0].dueDate} disabled />
              </div>
            </div>
          </InlineInputControlRow>

        </div>

        <div style={{ marginLeft: '150px', width: '210px' }}>
          <InlineInputControlRow label="Invoice #" mode="smaller-2x">
            <TextBox value={edi310.lines[0].invoiceNo} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Amount" mode="smaller-2x">
            <Float value={edi310.lines[0].amount} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Send Date" mode="smaller-2x">
            <IfmsDate value={edi310.lines[0].ediDate ?? ''} disabled />
          </InlineInputControlRow>
        </div>
      </div>

      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          disabled={run}
          onClick={clickEDI}>
          SEND TO EDI
        </SecondaryButton>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          onClick={onPopupClose}>
          CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
}

const Edi310 = ({
  onPopupClose,
  selectedElement
}: { onPopupClose?: () => void, selectedElement: InvoiceListItem }) => {
  return (
    <Edi310Impl selectedElement={selectedElement} onPopupClose={onPopupClose} key={`edi310-details`} />
  );
};
export default Edi310;
